import { useEffect, useState } from "react";
import {
  BarChart3, BookOpen, Briefcase, Building2, FileText, GraduationCap,
  Handshake, IndianRupee, Users,
} from "lucide-react";
import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { LoadingGrid, StatCard, inr } from "@/components/bits";
import { CronHealth } from "@/components/CronHealth";
import api from "@/lib/api";

export default function AdminDashboard() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/admin/overview").then(({ data }) => setData(data)).catch(() => setData({}));
  }, []);

  if (!data) return <LoadingGrid count={8} />;

  const funnel = [
    { name: "Jobs", value: data.jobs_total },
    { name: "Published", value: data.jobs_published },
    { name: "Applications", value: data.applications },
    { name: "Placements", value: data.placements },
    { name: "Courses", value: data.courses },
    { name: "Enrollments", value: data.enrollments },
  ];

  return (
    <div data-testid="admin-dashboard">
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        <StatCard label="Total Users" value={data.users} icon={Users} />
        <StatCard label="Employers" value={data.employers} icon={Building2} />
        <StatCard label="Candidates" value={data.candidates} icon={FileText} />
        <StatCard label="Partners" value={data.partners} icon={Handshake} />
        <StatCard label="Jobs Pending Review" value={data.jobs_pending_review} icon={Briefcase} accent />
        <StatCard label="Courses Pending" value={data.courses_pending} icon={BookOpen} accent />
        <StatCard label="Payouts Pending" value={data.payouts_pending} icon={IndianRupee} accent />
        <StatCard label="Institutes" value={data.institutes} icon={GraduationCap} />
      </div>

      <div className="grid lg:grid-cols-3 gap-6 mt-8">
        <div className="navy-bg rounded-xl p-7 text-white">
          <p className="text-white/60 text-sm">Monthly Recurring Revenue</p>
          <p className="font-heading font-extrabold text-3xl gold-text mt-2" data-testid="admin-mrr">{inr(data.mrr)}</p>
          <p className="text-white/60 text-sm mt-6">Total platform revenue</p>
          <p className="font-heading font-bold text-xl mt-1" data-testid="admin-revenue">{inr(data.revenue_total)}</p>
          <p className="text-white/40 text-xs mt-6">{data.active_subscriptions} active employer subscriptions</p>
        </div>
        <div className="lg:col-span-2 bg-white border border-border/60 rounded-xl p-6">
          <h3 className="font-heading font-semibold text-[#0B1B3D] mb-4 flex items-center gap-2">
            <BarChart3 className="w-4 h-4 text-[#2563EB]" /> Platform funnel
          </h3>
          <ResponsiveContainer width="100%" height={240}>
            <BarChart data={funnel}>
              <XAxis dataKey="name" tick={{ fontSize: 11 }} />
              <YAxis tick={{ fontSize: 11 }} allowDecimals={false} />
              <Tooltip />
              <Bar dataKey="value" fill="#2563EB" radius={[6, 6, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
      <CronHealth />
    </div>
  );
}
